import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface Features { tastings: boolean; gift_club: boolean; festive_banner: boolean; shop_header: boolean }

export const useFeatures = () => useQuery<Features>({ queryKey: ["features"], queryFn: () => api.get("/features").then((r) => r.data), staleTime: 300000 });
